import { useEffect } from "react";
import "./AtivarDesvioNegarModal.css";

export default function AtivarDesvioNegarModal({ open, label, onClose, onConfirm }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose, onConfirm]);

  if (!open) return null;

  return (
    <div className="dvenam-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="dvenam-modal" role="dialog" aria-modal="true" aria-label="Ativar item">
        <header className="dvenam-header">
          <h3 className="dvenam-title">Ativar</h3>
          <button type="button" className="dvenam-close" aria-label="Fechar" onClick={onClose}>
            x
          </button>
        </header>

        <div className="dvenam-body">
          Deseja <strong>ativar</strong> "{label || "este item"}"?
        </div>

        <footer className="dvenam-footer">
          <button type="button" className="dvenam-btn dvenam-btn--ghost" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="dvenam-btn dvenam-btn--primary" onClick={onConfirm}>
            Ativar
          </button>
        </footer>
      </div>
    </div>
  );
}
